export enum Fields {
    STATUS = 'status',
    INVOICE_REASON = 'invoiceReason',
    INVOICE_DATE = 'invoiceDate',
    TOTAL_REDUCTION = 'totalReduction',
    NET_TOTAL = 'netTotal',
}
